export default __webpack_public_path__ + "static/media/222.5f92732e.jpg";